import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {questionnaireActions} from "_actions";
import "./informes.scss"
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {xcService} from "../../../_services/xcService";
import {useLocation} from "react-router-dom";
import * as _ from "lodash";
import Tek4Eso from "./tek/tek4eso";
import Tek3Eso from "./tek/tek3eso";
import Tek2Bac from "./tek/tek2bac";
import Tek1Bac from "./tek/tek1bac";
import TekFPB from "./tek/tekfpb";
import TekFPM from "./tek/tekfpm";
import TekPdf from "./tek/tek.pdf";

import {isBrowser} from 'react-device-detect';

function InformeTekSimple(props) {


    const dispatch = useDispatch();
    const {query, search} = useLocation();

    const {t} = useTranslation();
    const [answers, setAnswers] = useState([]);
    const [userQuest, setUserQuest] = useState();
    const [code, setCode] = useState();
    const [course, setCourse] = useState();
    const [answersNoGame3, setAnswersNoGame3] = useState(null);
    const [answersNoGame4, setAnswersNoGame4] = useState(null);
    const [answersNoGame5, setAnswersNoGame5] = useState(null);
    const [answersNoGame6, setAnswersNoGame6] = useState(null);
    const [answersCervo, setAnswersCervo] = useState(null);
    const [answersTek, setAnswersTek] = useState(null);
    const [questionnaires, setQuestionnaires] = useState([]);
    const [timeline, setTimeline] = useState(null);
    const [studentHistory, setStudentHistory] = useState();
    const [levels, setLevels] = useState();
    const [studentAreaCervo, setStudentAreaCervo] = useState();
    const year = +new URLSearchParams(search).get('year');

    const setQuest = async (course) => {
        const quests = {
            '3º ESO': 'TEK3ESO',
            '4º ESO': 'TEK4ESO',
            '1º Bachillerato': 'TEK1BAC',
            '2º Bachillerato': 'TEK2BAC',
            'FP Grado Básico': 'TEKFPB',
            'FP Grado Medio': 'TEKFPM',
        }

        setUserQuest(quests[course])

        const answersPath = userType === 'STUDENT' ? `/v1/student/answers/${quests[course]}?year=${year}` : `/v1/student/${studentUid}/answers/${quests[course]}?year=${year}`;
        const resp = await xcService.getToken(answersPath);
        setAnswers(resp.data.data)



    }


    const items1 = {
        '3º ESO': 4,
        '4º ESO': year < 23 ? 6 : 7,
        '1º Bachillerato': 7,
        '2º Bachillerato': 7,
        'FP Grado Básico': 5,
        'FP Grado Medio': 5,
    }

    const items2 = {
        '3º ESO': 14,
        '4º ESO': 14,
        '1º Bachillerato': 13,
        '2º Bachillerato': 10,
        'FP Grado Básico': 11,
        'FP Grado Medio': 10,
    }
    const items3 = {
        '3º ESO': 8,
        '4º ESO': 7,
        '1º Bachillerato': 11,
        '2º Bachillerato': 8,
        'FP Grado Básico': 6,
        'FP Grado Medio': 6,
    }


    const [timelineData, setTimelineData] = useState([]);

    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));

    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');
    const [studentProfile, setStudentProfile] = useState();
    const [studentArea, setStudentArea] = useState();

    const getHistory = () => {
        if (studentUid){

            xcService.getToken(`/v1/${userType === 'STUDENT' ? `student/profile/history/` : `master/${studentUid}/history/`}${year}`)
                .then(({data}) => {
                    setStudentHistory(data.data)
                    let mStudentProfile = studentProfile;
                    setQuest(data.data.course.name);
                    setCourse(data.data.course.name)
                    mStudentProfile.course.id = data.data.course.id;
                    mStudentProfile.course.name = data.data.course.name;
                    setStudentProfile(mStudentProfile);
                })

        }
    }
    useEffect(() => {
        if (studentUid && (userType !== 'STUDENT')) xcService.getToken(`/v1/student/${studentUid}/profile`)
            .then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            })
        else {
            //setStudentProfile(localOrSessionStore({key: variables.USER}))

            xcService.getToken('/v1/me').then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            });

        }


    }, [studentUid]);
    var questionnairesData = useSelector((state) => state.questionnaireReducer.questionnairesData);
    var questionnairesDataError = useSelector((state) => state.questionnaireReducer.questionnairesDataError);


    var getStudentArea = useSelector((state) => state.questionnaireReducer.getStudentArea);


    const showResponse = (item) => {
        let mQuestion = item.assessment?.question;
        if (item.response) {
            return "<strong>" + mQuestion + "</strong> " + item.response?.question
        } else {
            if (item.degree) {
                return "<strong>" + mQuestion + "</strong> " + item.degree.title + " (" + item.degree.family + ")"
            }
            if (item.subject) {
                return "<strong>" + mQuestion + "</strong> " + item.subject.modality + " - " + item.subject.subject
            }
        }
    }

    const passTen = (value) => {
        if (value <= -2.25) {
            return 0;
        } else {
            if (value > -2.25 && value <= -1.75) {
                return 1
            } else if (value > -1.75 && value <= -1.25) {
                return 2
            } else if (value > -1.25 && value <= -0.75) {
                return 3
            } else if (value > -0.75 && value <= -0.25) {
                return 4
            } else if (value > -0.25 && value <= 0.25) {
                return 5
            } else if (value > 0.25 && value <= 0.75) {
                return 6
            } else if (value > 0.75 && value <= 1.25) {
                return 7
            } else if (value > 1.25 && value <= 1.75) {
                return 8
            } else if (value > 1.75 && value <= 2.25) {
                return 9
            } else {
                return 10
            }
        }
    }

    useEffect(() => {

        dispatch(questionnaireActions.getArea())
        const variablesRequests = [
            'POTENCACAD23',
            'WBACADTOT23',
            'AUTOCONFV23',
            'SWPERTOT23',
            'INFVOCTOT23',
            'MEDIA_NIVEL_ACADEMICO',
            'DESV_NIVEL_ACADEMICO',
            'MEDIA_INFORMACION_VOCA',
            'DESV_INFORMACION_VOCA',
            'MEDIA_AUTOCONFIANZA',
            'DESV_AUTOCONFIANZA',
            'MEDIA_BIENESTAR_ESCOLAR',
            'DESV_BIENESTAR_ESCOLAR',
            'DESV_AUTOCONFIANZA',
            'MEDIA_BIENESTAR_PERSONAL',
            'DESV_BIENESTAR_PERSONAL'
        ].map(variable =>
            xcService.getToken(`/v1/${userType === 'STUDENT' ? 'student' : 'tutor'}/${studentUid}/variable/${variable}?year=${year}`)
        );
        Promise.all(variablesRequests)
            .then(arr => {
                    const res = arr.reduce(
                        (obj, {data}) => ({...obj, ...data.data}),
                        {}
                    )
                    return res;
                }
            )
            .then(vars => {
                setLevels([
                    {
                        name: t("informes.respuestas.tres1"),
                        points: vars.POTENCACAD23 ?
                            vars.POTENCACAD23 : -100,
                        qName: t("informes.pendiente.thistoria")
                    }, {
                        name: t("informes.respuestas.tres2"),
                        points: vars.INFVOCTOT23 ? vars.INFVOCTOT23 : -100,
                        qName: t("informes.pendiente.treflexion")
                    }, {
                        name: t("informes.respuestas.tres3"),
                        points: vars.AUTOCONFV23 ? vars.AUTOCONFV23 : -100,
                        qName: t("informes.pendiente.treflexion")
                    }, {
                        name: t("informes.respuestas.tres4"),
                        points: vars.WBACADTOT23 ? vars.WBACADTOT23 : -100,
                        qName: t("informes.pendiente.tmibienestar")
                    }, {
                        name: t("informes.respuestas.tres5"),
                        points: vars.SWPERTOT23 ? vars.SWPERTOT23 : -100,
                        qName: t("informes.pendiente.tmibienestar")
                    },
                ])
            })
    }, []);


    useEffect(() => {
        if (!userType) return;

        const questionPath = userType === 'STUDENT' ? `/v1/student/myquestionnaires?year=${year}` : `/v1/student/${studentUid}/questionnaires?year=${year}`;
        xcService.getToken(questionPath).then(({data}) => {


            setQuestionnaires(data.data)
            let mNoGame3 = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM3';
                }
            );
            if (mNoGame3 && mNoGame3[0] && mNoGame3[0].totresp === mNoGame3[0].tota) {
                const mUrl =userType === 'STUDENT' ? `/v1/student/answers/NOGAM3?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM3?withResponses=true&year=${year}`;
                xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame3(data.data));

            }

            let mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM4';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                const mUrl =userType === 'STUDENT' ? `/v1/student/answers/NOGAM4?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM4?withResponses=true&year=${year}`;

                xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame4(data.data));
            }


            mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM5';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                const mUrl =userType === 'STUDENT' ? `/v1/student/answers/NOGAM5?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM5?withResponses=true&year=${year}`;

                xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame5(data.data));
            }


            mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM6';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                const mUrl =userType === 'STUDENT' ? `/v1/student/answers/NOGAM6?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM6?withResponses=true&year=${year}`;
                xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame6(data.data));
            }

            mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'CERVO';
                }
            );
           // if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                const mUrl2 =userType === 'STUDENT' ? `/v1/student/answers/CERVO?withResponses=true&year=${year}` :
                    `/v1/student/${studentUid}/answers/CERVO?year=${year}`;
                xcService.getToken(mUrl2).then(({data}) =>{
                    setAnswersCervo(data.data)
                });
           // }

            const areaPath = userType === 'STUDENT' ? `/v1/student/area/CEIBA?year=${year}` : `/v1/student/${studentUid}/area/CEIBA?year=${year}`
            xcService.getToken(areaPath).then(({data}) => setStudentArea(data.data));

            const areaCevoPath = userType === 'STUDENT' ? `/v1/student/area/CERVO?year=${year}` : `/v1/student/${studentUid}/area/CERVO?year=${year}`
            xcService.getToken(areaCevoPath).then(({data}) => setStudentAreaCervo(data.data));



            const mUrl =userType === 'STUDENT' ? `/v1/student/course?year=${year}` : `/v1/student/course/${studentUid}/${year}`;


        })



    }, [userType, course]);


    const getResponse = (array, code) => {
        let mResult = _.filter(array, function (o) {
            return o.assessment.order === code
        });

        if (mResult && mResult.length > 0) {

            if (mResult[0].assessment.questionType === "RATING") {

                return <p>{mResult[0].points}</p>
            } else if (mResult[0].assessment.questionType === "RATINGOB") {

                return <p>{mResult[0].yesno === 1 ? t("yes") + ". " + mResult[0].points : t("no")}</p>
            } else {
                if (mResult[0].response) {
                    return <p>{mResult[0]?.response?.question}</p>
                } else {
                    if (mResult[0].degree) {
                        return <p>{mResult[0]?.degree?.family} {mResult[0]?.degree?.title}</p>
                    }
                }
            }
            return "";

        } else {
            return <p dangerouslySetInnerHTML={{__html: t("informes.pendiente.miproyecto")}}/>
        }

    }


    return (
        <div className={"container dasboard-informes"}>
            <div style={{
                width: "100%", height: "100%"
            }}>
                <>


                    {studentProfile && answers.length > 0 && userQuest === "TEK4ESO" &&
                        <Tek4Eso forDownload={true}  setTimeline={setTimeline} answers={answers} studentProfile={studentProfile}/>
                    }
                    {studentProfile && answers.length > 0 && userQuest === "TEK3ESO" &&
                        <Tek3Eso  forDownload={true}  setTimeline={setTimeline} answers={answers} studentProfile={studentProfile}/>
                    }
                    {studentProfile && answers.length > 0 && userQuest === "TEK1BAC" &&
                        <Tek1Bac  forDownload={true}  setTimeline={setTimeline} answers={answers} studentProfile={studentProfile}/>
                    }
                    {studentProfile && answers.length > 0 && userQuest === "TEK2BAC" &&
                        <Tek2Bac forDownload={true}  setTimeline={setTimeline} answers={answers} studentProfile={studentProfile}/>
                    }
                    {studentProfile && answers.length > 0 && userQuest === "TEKFPB" &&
                        <TekFPB  forDownload={true}  setTimeline={setTimeline} answers={answers} studentProfile={studentProfile}/>
                    }
                    {studentProfile && answers.length > 0 && userQuest === "TEKFPM" &&

                        <TekFPM  forDownload={true}  setTimeline={setTimeline} answers={answers} studentProfile={studentProfile}/>
                    }

                    {studentProfile && answers && answers.length > 0 && timeline &&

                            <TekPdf  forDownload={isBrowser ? true : false} timeline={timeline} props={props} studentProfile={studentProfile}
                                    answers={answers} levels={levels}
                                    getStudentArea={getStudentArea}
                                    answersCervo={answersCervo}
                                    answersNoGame3={answersNoGame3}
                                    answersNoGame4={answersNoGame4}
                                    answersNoGame5={answersNoGame5}
                                     studentHistory={studentHistory}
                                    answersNoGame6={answersNoGame6}
                                    studentAreaCervo={studentAreaCervo} course={course}
                                    studentArea={studentArea}/>

                        }

                </>
            </div>
        </div>
    )

}

export default withTranslation()(InformeTekSimple);


